const i = ({
  condition: n,
  wrapper: t,
  wrappedJSX: o
}) => n ? t(o) : o;
export {
  i as ConditionalWrap
};
